import { getValue } from "../../../common/getValue";

const results = {
  data: {
    orders: {
      count: 3,
      rows: [
        {
          orderId: 1239238,
          status: 1,
          customerName: "Jack Sparrow",
          customerId: 1769870,
          paymentMethod: "Bank Transfer",
          totalValue: 65156000,
          created: "2019-09-14T04:06:55.416Z",
          updated: "2019-09-15T04:06:55.416Z",
        },
        {
          orderId: 1239238,
          status: 2,
          customerName: "Jack Sparrow",
          customerId: 1769870,
          paymentMethod: "Bank Transfer",
          totalValue: 65156000,
          created: "2019-09-14T04:06:55.416Z",
          updated: "2019-09-15T04:06:55.416Z",
        },
        {
          orderId: 1239238,
          status: 3,
          customerName: "Jack Sparrow",
          customerId: 1769870,
          paymentMethod: "Bank Transfer",
          totalValue: 65156000,
          created: "2019-09-14T04:06:55.416Z",
          updated: "2019-09-15T04:06:55.416Z",
        },
        {
          orderId: 1239238,
          status: 4,
          customerName: "Jack Sparrow",
          customerId: 1769870,
          paymentMethod: "Bank Transfer",
          totalValue: 65156000,
          created: "2019-09-14T04:06:55.416Z",
          updated: "2019-09-15T04:06:55.416Z",
        },
      ],
    },
  },
  status: 200,
};

const payment_confirmation = {
  status: 200,
  data: {
    orderStatus: "payment_confirmation",
    orderPayment: {
      paymentStatus: "",
      paymentName: "Bank Transfer",
      paymentValue: "1506400",
      paymentNote: "",
      paymentProof: "",
    },
    orderDetail: {
      item: [
        {
          oracleItemId: "255796",
          itemName: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          description: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          qty: 5,
          oraclePriceListId: "1408329",
          picture:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          thumbnail:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          discount: "",
          price: {
            itemPrice: 108000,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
        {
          oracleItemId: "122760",
          itemName: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          description: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          qty: 8,
          oraclePriceListId: "1407701",
          picture:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          thumbnail:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          discount: "",
          price: {
            itemPrice: 120800,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
      ],
      discount: [],
    },
    ship_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    bill_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    shipping: {
      estimateArrival: "",
      status: "",
    },
    document: {
      proof_of_delivery: "",
      temporary_invoice: "",
      permanent_invoice: "",
      faktur_pajak: "",
    },
  },
};
const on_progress = {
  status: 200,
  data: {
    orderStatus: "on_progress",
    orderPayment: {
      paymentStatus: "",
      paymentName: "Bank Transfer",
      paymentValue: "1506400",
      paymentNote: "Pembayaran masuk pada jam 07:00, 12 September 2019",
      paymentProof:
        "https://files.moota.co/uploads/2019/03/gambar-artikel1.png",
    },
    orderDetail: {
      item: [
        {
          oracleItemId: "255796",
          itemName: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          description: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          qty: 5,
          oraclePriceListId: "1408329",
          picture:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          thumbnail:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          discount: "",
          price: {
            itemPrice: 108000,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
        {
          oracleItemId: "122760",
          itemName: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          description: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          qty: 8,
          oraclePriceListId: "1407701",
          picture:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          thumbnail:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          discount: "",
          price: {
            itemPrice: 120800,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
      ],
      discount: [],
    },
    ship_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    bill_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    shipping: {
      estimateArrival: "",
      status: "",
    },
    document: {
      proof_of_delivery: "",
      temporary_invoice: "",
      permanent_invoice: "",
      faktur_pajak: "",
    },
  },
};

const on_delivery = {
  status: 200,
  data: {
    orderStatus: "delivery",
    orderPayment: {
      paymentStatus: "",
      paymentName: "Bank Transfer",
      paymentValue: "1506400",
      paymentNote: "Pembayaran masuk pada jam 07:00, 12 September 2019",
      paymentProof:
        "https://files.moota.co/uploads/2019/03/gambar-artikel1.png",
    },
    orderDetail: {
      item: [
        {
          oracleItemId: "255796",
          itemName: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          description: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          qty: 5,
          oraclePriceListId: "1408329",
          picture:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          thumbnail:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          discount: "",
          price: {
            itemPrice: 108000,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
        {
          oracleItemId: "122760",
          itemName: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          description: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          qty: 8,
          oraclePriceListId: "1407701",
          picture:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          thumbnail:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          discount: "",
          price: {
            itemPrice: 120800,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
      ],
      discount: [],
    },
    ship_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    bill_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    shipping: {
      estimateArrival: "16-09-2019",
      status: "Dalam Pengiriman",
    },
    document: {
      proof_of_delivery: "",
      temporary_invoice: "",
      permanent_invoice: "",
      faktur_pajak: "",
    },
  },
};
const done = {
  status: 200,
  data: {
    orderStatus: "done",
    orderPayment: {
      paymentStatus: "",
      paymentName: "Bank Transfer",
      paymentValue: "1506400",
      paymentNote: "Pembayaran masuk pada jam 07:00, 12 September 2019",
      paymentProof:
        "https://files.moota.co/uploads/2019/03/gambar-artikel1.png",
    },
    orderDetail: {
      item: [
        {
          oracleItemId: "255796",
          itemName: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          description: "RELAXA EMUTZ BOX (12x30) PCS (POLOS)",
          qty: 5,
          oraclePriceListId: "1408329",
          picture:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          thumbnail:
            "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/4/12/170264939/170264939_c8969a8c-0f1b-4434-8038-afcd97e8403c_600_600.jpg",
          discount: "",
          price: {
            itemPrice: 108000,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
        {
          oracleItemId: "122760",
          itemName: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          description: "OATBITS STRAWBERRY YOGHURT (ROLL, 4X5X121 GR) - MM",
          qty: 8,
          oraclePriceListId: "1407701",
          picture:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          thumbnail:
            "https://www.static-src.com/wcsstore/Indraprastha/images/catalog/medium/oatbits_oatbits-strawberry-yoghurt-roll---pack-of-6_full03.jpg",
          discount: "",
          price: {
            itemPrice: 120800,
            uomCode: "Box",
            defaultUomCode: "Box",
          },
        },
      ],
      discount: [],
    },
    ship_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    bill_to: {
      ship_to_site_use_id: "4173825",
      country: "ID",
      province: "Jawa Tengah",
      city: "SEMARANG",
      state: "SEMARANG",
      address: "PASAR MANGKANG A.3 WONOSARI NGALIYAN  ",
      postal_code: "50244",
      phone_number: "",
      contact_person: "HELMI HIDAYATI",
      contact_phone_number: "",
    },
    shipping: {
      estimateArrival: "16-09-2019",
      status: "Pengiriman Selesai",
    },
    document: {
      proof_of_delivery: "",
      temporary_invoice: "",
      permanent_invoice: "",
      faktur_pajak: "",
    },
  },
};

const defaultRetur = (payload) => {
  const retur = {
    discount: getValue(payload.retur, "discount", []),
    orderDetail: getValue(payload.retur, "orderDetail", []),
    returStatus: getValue(payload.retur, "returStatus", ""),
    orderDate: getValue(payload.retur, "orderDate", ""),
    subTotal: getValue(payload.retur, "subTotal", 0),
    taxRate: getValue(payload.retur, "taxRate", 0),
    total: getValue(payload.retur, "total", 0),
    oracleCustomerId: getValue(payload.retur, "oracleCustomerId", ""),
    returId: getValue(payload.retur, "orderId", ""),
    photos: getValue(payload.retur, "photos", ""),
    customerName: getValue(payload.retur, "customerName", ""),
  };
  const payment = {
    bankAccountCustomer: {
      paymentSlipUrl: getValue(payload, "payment.paymentSlipUrl", ""),
      notes: getValue(payload, "payment.notes", "-"),
      paymentAmount: getValue(payload, "payment.paymentAmount", 0),
    },
    paymentCode: getValue(payload, "paymentTerm", "-"),
    billAmount: getValue(payload, "payment.billAmount", 0),
    _id: getValue(payload, "payment._id", ""),
    status: getValue(payload, "payment.status", "-"),
    estimateArrival: getValue(payload, "payment.estimateArrival", "-"),
  };
  const shipTo = {
    country: getValue(payload, "shipTo.country", "-"),
    province: getValue(payload, "shipTo.province", "-"),
    city: getValue(payload, "shipTo.city", "-"),
    state: getValue(payload, "shipTo.state", "-"),
    address: getValue(payload, "shipTo.address", "-"),
    postal_code: getValue(payload, "shipTo.postalCode", "-"),
    phone_number: getValue(payload, "shipTo.primaryPhoneNumber", "-"),
    contact_person: getValue(payload, "shipTo.contactPerson", "-"),
    contact_phone_number: getValue(payload, "shipTo.contactPhoneNumber", "-"),
  };
  const billTo = {
    country: getValue(payload, "billTo.country", "-"),
    province: getValue(payload, "billTo.province", "-"),
    city: getValue(payload, "billTo.city", "-"),
    state: getValue(payload, "billTo.state", "-"),
    address: getValue(payload, "billTo.address", "-"),
    postal_code: getValue(payload, "billTo.postalCode", "-"),
    phone_number: getValue(payload, "billTo.primaryPhoneNumber", "-"),
    contact_person: getValue(payload, "billTo.contactPerson", "-"),
    contact_phone_number: getValue(payload, "billTo.contactPhoneNumber", "-"),
  };
  const branchCodeData = {
    branch: getValue(payload, "billTo.branch", "-"),
  };
  const data = {
    retur,
    payment,
    shipTo,
    billTo,
    branchCodeData,
  };
  return data;
};

export {
  results,
  payment_confirmation,
  on_progress,
  on_delivery,
  done,
  defaultRetur,
};
